import FeaturedRail from '@ulta/components/FeaturedRail/FeaturedRail';

export default FeaturedRail;
